import type { JourneyDefinition, PlanStep } from "../plan.types";

const steps: PlanStep[] = [
  {
    id: "prepare",
    title: "Prepare for trying naturally",
    subtitle: "Review the health context you already have",
    icon: "HeartPulse",
    education: {
      context:
        "Start with your medical history, medications, cycle context, and any questions you want to bring to a clinician.",
    },
    actions: [
      {
        label: "Continue medical history",
        variant: "primary",
        screen: "MedicalHistory",
      },
      {
        label: "Learn about preconception",
        variant: "outline",
        screen: "LearnScreen",
      },
    ],
    completionSignal: {
      type: "completion-percent",
      field: "medicalHistory",
      threshold: 100,
    },
  },
  {
    id: "cycle",
    title: "Understand your cycle",
    subtitle: "Use cycle data when it helps you",
    icon: "CalendarClock",
    education: {
      context:
        "Cycle history can help you notice patterns, but calendar estimates are not a diagnosis and do not confirm ovulation.",
    },
    actions: [
      {
        label: "Open Care",
        variant: "primary",
        screen: "CareOverview",
      },
    ],
    completionSignal: { type: "data-exists", check: "periods" },
  },
  {
    id: "care",
    title: "Know when to seek care",
    subtitle: "Keep evaluation available if your needs change",
    icon: "Stethoscope",
    education: {
      context:
        "Your timeline, symptoms, risk factors, and questions can all inform when a conversation with a healthcare professional is useful.",
    },
    actions: [
      {
        label: "Find care",
        variant: "primary",
        screen: "FindCareScreen",
      },
    ],
    completionSignal: { type: "external" },
  },
  {
    id: "next-step",
    title: "Choose your next step",
    subtitle: "Continue trying, pause, or explore an option",
    icon: "Route",
    education: {
      context:
        "When you are ready, you can keep trying, pause, ask for an evaluation, or make an explicit treatment decision without losing your history.",
    },
    actions: [
      {
        label: "Open Care",
        variant: "primary",
        screen: "CareOverview",
      },
    ],
    completionSignal: { type: "external" },
  },
];

export const TRYING_NATURALLY: JourneyDefinition = {
  key: "trying-naturally",
  gender: "female",
  goal: "pregnancy",
  pathway: "solo",
  title: "Trying naturally",
  description:
    "A non-treatment path for preparing, tracking what helps, and knowing when to seek care.",
  steps,
};
